// extracted by mini-css-extract-plugin
export default {"doc":"Terms_doc__Ogm39"};